import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Spinner, Alert } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { connect } from "react-redux";
import { useNavigate } from 'react-router-dom';
import "./style.css"
const Registration = ({ user}) => {
    const [step, setStep] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        phone: '',
        password: '',
        confirmPassword: '',
        birth: '',
        token: '',
    });
    const [userId, setUserId] = useState(null);
    const [emailError, setEmailError] = useState('');
    const [tokenError, setTokenError] = useState('');
    const [showCorrectEmail, setShowCorrectEmail] = useState(false);
    const [newEmail, setNewEmail] = useState('');
    const [newEmailError, setNewEmailError] = useState('');
    const [correctEmailStatus, setCorrectEmailStatus] = useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
        if (name === 'email') setEmailError('');
    };
    const handleEmailBlur = () => {
        if (formData.email && !validateEmail(formData.email)) {
            setEmailError('請輸入有效的電子郵件地址');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const response = await fetch(process.env.REACT_APP_API_URL + '/api/registry', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                window.alert("使用者名稱或EMAIL已存在，請直接登入。");
                throw new Error(response.statusText);
            }
            const data = await response.json();
            setUserId(data.user_id);
            setStep(2);
        } catch (error) {
            console.error('There was a problem with the login request:', error);
            // Handle login error
        } finally {
            setIsLoading(false);
        }
        // Handle form submission logic here
        // console.log(formData);
    };
    const handleTokenSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setTokenError('');
        try {
            const response = await fetch(process.env.REACT_APP_API_URL + '/api/verifyemail?token=' + formData.token);
            if (!response.ok) {
                setTokenError('驗證碼錯誤或已過期，請再試一次。');
                throw new Error(response.statusText);
            }
            setStep(3);
        } catch (error) {
            console.error('There was a problem with the verification request:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleCorrectEmail = async (e) => {
        e.preventDefault();
        if (!validateEmail(newEmail)) {
            setNewEmailError('請輸入有效的電子郵件地址');
            return;
        }
        setCorrectEmailStatus('sending');
        try {
            const response = await fetch(process.env.REACT_APP_API_URL + '/api/correctregistrationemail', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ user_id: userId, email: newEmail }),
            });
            if (response.status === 409) {
                setNewEmailError('此電子郵件已被使用，請換一個。');
                setCorrectEmailStatus(null);
                return;
            }
            if (!response.ok) {
                setCorrectEmailStatus('error');
                return;
            }
            setFormData({ ...formData, email: newEmail, token: '' });
            setNewEmail('');
            setShowCorrectEmail(false);
            setCorrectEmailStatus(null);
            setTokenError('');
        } catch {
            setCorrectEmailStatus('error');
        }
    };

    const isFormValid = () => {
        return (
            formData.username.trim() !== '' &&
            formData.email.trim() !== '' &&
            validateEmail(formData.email) &&
            formData.phone.trim() !== '' &&
            formData.birth &&
            formData.password.trim() !== '' &&
            formData.confirmPassword.trim() !== '' &&
            formData.password === formData.confirmPassword
        );
    };
    if (user){
        navigate('/account');
    }
    return (
        <Container>
            <Row className="justify-content-md-center mb-5">
                <Col md="6">
                    <h2>帳號註冊</h2>
                    <div className="stepper">
                        <div className={` ${step === 1 ? 'activestep' : 'inactivestep'}`}>Step 1: 基本資料</div>
                        <div className={`step ${step === 2 ? 'activestep' : 'inactivestep'}`}>Step 2: 安全性</div>
                        <div className={`step ${step === 3 ? 'activestep' : 'inactivestep'}`}>Step 3: 完成</div>
                    </div>
                    {step === 1 && (
                        <Form>
                            <Form.Group controlId="formUsername" className='my-3'>
                                <Form.Label>使用者名稱*</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="username"
                                    value={formData.username}
                                    onChange={handleChange}
                                    placeholder="Enter username"
                                />
                            </Form.Group>

                            <Form.Group controlId="formEmail" className='my-3'>
                                <Form.Label>Email 地址*</Form.Label>
                                <Form.Control
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    onBlur={handleEmailBlur}
                                    placeholder="Enter email"
                                    isInvalid={!!emailError}
                                />
                                <Form.Control.Feedback type="invalid">{emailError}</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group controlId="formPhone" className='my-3'>
                                <Form.Label>手機號碼*</Form.Label>
                                <Form.Control
                                    type="phone"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    placeholder="Enter phone"
                                />
                            </Form.Group>
                            <Form.Group controlId="formBirth" className='my-3'>
                                <Form.Label>出生年月日*</Form.Label>
                                <Form.Control
                                    type="date"
                                    name="birth"
                                    value={formData.birth}
                                    onChange={handleChange}
                                    placeholder="Enter birthday"
                                />
                            </Form.Group>
                            <Form.Group controlId="formPassword" className='my-3'>
                                <Form.Label>新的密碼*</Form.Label>
                                <Form.Control
                                    type="password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    placeholder="Password"
                                />
                            </Form.Group>
                            <Form.Group controlId="formConfirmPassword" className='my-3'>
                                <Form.Label>再打一次密碼*</Form.Label>
                                <Form.Control
                                    type="password"
                                    name="confirmPassword"
                                    value={formData.confirmPassword}
                                    onChange={handleChange}
                                    placeholder="Confirm Password"
                                />
                            </Form.Group>

                            <Button variant="dark" onClick={handleSubmit} disabled={!isFormValid()}>
                                {isLoading===true?<Spinner animation="border" role="status"  style={{marginLeft: '20px'}}>
                                    <span className="sr-only"></span>
                                </Spinner>
                                :"下一步"}
                            </Button>
                        </Form>
                    )}
                    {step === 2 && (
                        <div className='mt-4'>
                            <Alert variant="info">
                                <Alert.Heading style={{ fontSize: '1rem', fontWeight: 'bold' }}>
                                    驗證信已寄出 ✉
                                </Alert.Heading>
                                <p className='mb-1'>
                                    驗證碼已發送至：<strong>{formData.email}</strong>
                                </p>
                                <hr />
                                <p className='mb-1' style={{ fontSize: '0.9rem' }}>若未收到信件，請確認：</p>
                                <ul className='mb-0' style={{ fontSize: '0.9rem' }}>
                                    <li>是否被歸類至<strong>垃圾郵件</strong>或<strong>廣告信</strong>資料夾</li>
                                    <li>
                                        電子郵件地址是否有誤——
                                        <button
                                            type="button"
                                            className="btn btn-link p-0 align-baseline"
                                            style={{ fontSize: '0.9rem' }}
                                            onClick={() => { setShowCorrectEmail(v => !v); setNewEmailError(''); setCorrectEmailStatus(null); }}
                                        >
                                            {showCorrectEmail ? '取消' : '點此修改'}
                                        </button>
                                    </li>
                                </ul>
                            </Alert>

                            {showCorrectEmail && (
                                <Alert variant="warning" className='mb-3'>
                                    <p className='mb-2' style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>修改電子郵件地址</p>
                                    <Form.Control
                                        type="email"
                                        placeholder="請輸入正確的電子郵件地址"
                                        value={newEmail}
                                        onChange={(e) => { setNewEmail(e.target.value); setNewEmailError(''); setCorrectEmailStatus(null); }}
                                        isInvalid={!!newEmailError}
                                        className='mb-1'
                                    />
                                    <Form.Control.Feedback type="invalid">{newEmailError}</Form.Control.Feedback>
                                    {correctEmailStatus === 'error' && (
                                        <p className='text-danger mt-1 mb-1' style={{ fontSize: '0.85rem' }}>寄送失敗，請稍後再試。</p>
                                    )}
                                    <Button
                                        size="sm"
                                        variant="dark"
                                        className='mt-2'
                                        onClick={handleCorrectEmail}
                                        disabled={!newEmail.trim() || correctEmailStatus === 'sending'}
                                    >
                                        {correctEmailStatus === 'sending' ? '寄送中...' : '確認並重新寄送驗證信'}
                                    </Button>
                                </Alert>
                            )}

                            <Form.Group controlId="formToken" className='my-3'>
                                <Form.Label>請輸入驗證碼</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="token"
                                    value={formData.token}
                                    onChange={(e) => { handleChange(e); setTokenError(''); }}
                                    placeholder="請輸入信件中的驗證碼"
                                    isInvalid={!!tokenError}
                                />
                                <Form.Control.Feedback type="invalid">{tokenError}</Form.Control.Feedback>
                            </Form.Group>

                            <Button variant="dark" onClick={handleTokenSubmit} disabled={formData.token.trim() === '' || isLoading}>
                                {isLoading
                                    ? <Spinner animation="border" role="status" size="sm" />
                                    : '驗證並完成註冊'}
                            </Button>
                        </div>
                    )}
                    {step === 3 && (
                        <div>
                            <h3 className='mt-5'>信箱已驗證</h3>
                            <p>您可以開始選購琴譜！</p>
                            <Button variant="dark" href='/' style={{ marginRight: "20px" }}>
                                回首頁
                            </Button>
                        </div>
                    )}
                </Col>
            </Row>
        </Container>
    );
    
};
const mapStateToProps = (state) => {
    return {
      user: state.user.user,
    };
  };
export default connect(mapStateToProps)(Registration);